import api from "@/lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Avvia un'estrazione AI in background e ne segue l'avanzamento con polling:
// nessuna richiesta HTTP lunga => nessun timeout del proxy/Cloudflare.
export async function runExtraction({ url, payload, onProgress, maxMs = 12 * 60 * 1000 }) {
  const { data: start } = await api.post(url, payload);
  const jobId = start.job_id;
  const totale = start.totale || 0;
  onProgress?.({ fatti: 0, totale });
  const t0 = Date.now();
  while (Date.now() - t0 < maxMs) {
    await sleep(2000);
    let job;
    try {
      job = (await api.get(`/extract-jobs/${jobId}`)).data;
    } catch (e) {
      if (e?.response?.status === 404) throw e;
      continue; // errore di rete temporaneo: riprova al giro dopo
    }
    onProgress?.({ fatti: job.fatti || 0, totale: job.totale || totale });
    if (job.stato === "completo") return job;
    if (job.stato === "errore") throw new Error(job.messaggio || "Estrazione non riuscita");
  }
  throw new Error("L'estrazione sta impiegando troppo tempo. Riprova con meno documenti.");
}
